<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-col cols="12" sm="10" md="10">
        <v-sheet class="neu-glow with-radius">
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col
                cols="12"
                md="6"
                class="pa-0"
                v-if="$vuetify.breakpoint.mdAndUp"
              >
                <v-row
                  align="center"
                  justify="center"
                  class="fill-height px-6"
                >
                  <v-img
                    src="/static/ob-animated-isometric/secure-login-animate.svg"
                    lazy-src="/static/ob-animated-isometric/secure-login-animate.svg"
                  ></v-img>
                </v-row>
              </v-col>
              <!-- 2 -->
              <v-col cols="12" md="6" class="fluo">
                  <div class="my-8 d-flex justify-center flex-column align-center">
                    <div class="text-h4 d-flex justify-center">
                        <v-img
                          src="/static/logos/iBook2_logo.png"
                          eager
                          lazy-src="/static/logos/iBook2_logo.png"
                          max-width = "250"
                          contain
                        ></v-img>
                    </div>
                    <div class="text-subtitle-2 mt-1">{{$t(page+'.Hello, Welcome Back')}}</div>
                    <div class="title secondary--text mb-3">{{ username }}</div>
                    <vuse-neu-avatar
                      :src="settings.avatar?'/static/users/pictures/avatar/'+settings.avatar+'.png':'/static/users/pictures/avatar/unknown.png'"
                      glowClass="neu-glow-inset"
                    />
                    <div class="text-subtitle-2 mb-3">Session is over, please enter password to continue</div>
                  </div>
                  <v-sheet max-width="380" class="mx-auto" color="transparent">
                    <v-form
                      @submit.prevent="$v.$invalid ? null : submit()"
                      ref="form"
                    >
                      <v-text-field
                        :error-messages="fieldErrors('form.password').length>0?$t(page+'.'+fieldErrors('form.password')):null"
                        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPwd ? 'text' : 'password'"
                        @input="$v.form.password.$touch()"
                        @blur="$v.form.password.$touch()"
                        prepend-inner-icon="vpn_key"
                        v-model="form.password"
                        label="Password"
                        @click:append="showPwd = !showPwd"
                        outlined
                      />
                      <v-text-field
                        v-model="form.email"
                        hidden
                      />

                      <v-btn color="info" block type="submit" :disabled="$v.$invalid" :loading="loader"
                        >{{$t(page+'.Sign In')}}</v-btn
                      >
                      <div class="text-center my-5">
                        {{$t(page+'.Not')}} <span class="font-weight-black secondary--text" > {{ settings.username }} </span> ?
                        <router-link
                          to="/auth/login"
                          class="py-1 no-text-decoration"
                          >{{$t(page+'.Login with different account')}}</router-link
                        >
                      </div>
                    </v-form>
                  </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </v-sheet>
      </v-col>
    </v-container>
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span> {{$t(page+'.Signed In Successfully')}}</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
    <v-dialog persistent v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5 secondary mb-5"
          > {{$t(page+'.Sign In Error')}}</v-card-title
        >

        <v-card-text>
          <v-container>
          <h3 v-html="message"></h3>
          </v-container>
        </v-card-text>

        <v-card-actions  v-if="errorid!=='0007'">

          <v-btn color="red darken-1" dark to="/auth/forgotpassword">
             {{$t(page+'.Forgot PWD')}}
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="green darken-1" dark @click="dialog = !dialog">
             {{$t(page+'.Retry')}}
          </v-btn>
        </v-card-actions>

        <v-card-actions  v-else>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" dark @click="dialog = !dialog">
             {{$t(page+'.Close')}}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
const defaultForm = {
  email: JSON.parse(sessionStorage.getItem('settings')).email,
  password: "",
  rememberMe: false,
};
export default {
  mixins: [validationMixin],
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6),
      }
    },
  },
  validationMessages: {
    form: {
      password: {
        required: "Please enter password",
        minLength: "Password must be of 6 characters",
      },
    },
  },
  computed: {
     ...mapGetters(["settings"]),
  },
  data() {
    return {
      page:'Auth',
      settings:JSON.parse(sessionStorage.getItem('settings')),
      form: Object.assign({}, defaultForm),
      showPwd: false,
      snackbar: false,
      loader: false,
      username: JSON.parse(sessionStorage.getItem('settings')).username,
      avatar: JSON.parse(sessionStorage.getItem('settings')).avatar,
      dialog:false,
    };
  },
  methods: {
    async submit()
    {
      this.loader=true;
      try
      {
        const res = await this.$http.post('/auth/login.php', this.form)
        this.errorid=res.data.errorid;
        if (res.data.errorid=='0')
        {
          sessionStorage.setItem('jwt', res.data.jwt);
          var settings=JSON.parse(res.data.settings)
          //console.log(183,settings,settings.landingPage);
          const sy=['settings']
          sy.forEach(e=>{
            let payload=res.data[e];
            console.log(186,payload)
            console.log(190,e)           
            payload={"action":e,"pl":JSON.parse(res.data[e])};
            console.log(192,e,payload);
            this.$store.dispatch("synchro",payload);
          });
          this.$store.dispatch("setLocale", settings.locale);
          //this.$store.dispatch("setCurrency", settings.currency);          
          if (settings.level>100)
          {
            sessionStorage.setItem('jwt_b', res.data.jwt);
          }
          //this.$store.dispatch("setUser", res.data.user); 


          //this.$store.dispatch("setLocale", res.data.user.locale);
          //this.$store.dispatch("setCurrency", res.data.user.currency);
          
          if (settings)
          {
            sessionStorage.setItem('settings', JSON.stringify(settings));
            //localStorage.setItem('user', res.data.user);
          }
          else
          {
            sessionStorage.removeItem('settings');
          }
          //console.log('lp',res.data.user.landingpage);
          console.log(215,settings.landingPage);
          this.$router.push(settings.landingPage).catch(() => {});
        }
        else
        {
          this.message=res.data.message;
          this.dialog=true;
        }
      }       
      catch(e)
      {
        console.log('error',e)
        this.$router.push('/auth/login').catch(() => {});
      }
      this.loader=false;
    },
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
    },
  },
};
</script>
